import { createFileRoute } from "@tanstack/react-router";
import { MultilingualServiceLanding } from "@/components/MultilingualServiceLanding";
import { KO_TRANSLATE } from "@/data/ko-service-content";
import { SEO_SITE, multiHreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const PATH = "/ko/translate";
const C = KO_TRANSLATE;

export const Route = createFileRoute("/ko/translate")({
  head: () => ({
    meta: [
      { title: ctaTitle("방콕 한국어 인증 번역 (한↔태↔영) | NYC Legal", "/ko/translate", "th")},
      { name: "description", content: ctaDesc("MOJ 등록 번역사가 작성하는 한국어 인증 번역. MFA·대사관·이민국·DBD 인정 형식. 1~3 영업일. Talk to a specialist today; no obligation, fast reply.", "/ko/translate", "th")},
      { property: "og:title", content: ctaTitle("방콕 한국어 인증 번역 | NYC Legal", "/ko/translate", "th")},
      { property: "og:description", content: ctaDesc("한↔태↔영 인증 번역 + 아포스티유 원스톱. 카카오톡 견적.", "/ko/translate", "th")},
      { property: "og:url", content: `${SEO_SITE}${PATH}` },
      { property: "og:locale", content: "ko_KR" },
    ],
    links: [
      { rel: "canonical", href: `${SEO_SITE}${PATH}` },
      ...multiHreflangLinks(
        [
          { hreflang: "th-TH", path: "/translate" },
          { hreflang: "en", path: "/en/translate" },
          { hreflang: "zh", path: "/zh/translate" },
          { hreflang: "ja", path: "/ja/translate" },
          { hreflang: "ko", path: "/ko/translate" },
          { hreflang: "x-default", path: "/translate" },
        ],
        "/translate",
      ),
    ],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "ProfessionalService",
        name: "NYC Legal — 한국어 인증 번역", url: `${SEO_SITE}${PATH}`,
        areaServed: ["TH", "KR"], inLanguage: "ko",
        priceRange: "฿500–฿3,000", serviceType: "Certified Translation Korean–Thai–English",
        provider: { "@type": "Organization", name: "NYC Language Institute", url: SEO_SITE },
      }) },
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "FAQPage", inLanguage: "ko",
        mainEntity: C.faqs.map((f) => ({ "@type": "Question", name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a } })),
      }) },
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "홈", item: `${SEO_SITE}/ko` },
          { "@type": "ListItem", position: 2, name: "인증 번역", item: `${SEO_SITE}${PATH}` },
        ],
      }) },
    ],
  }),
  component: () => <MultilingualServiceLanding c={C} />,
});
